import { render } from "./TmpPatientCard.vue?vue&type=template&id=6f4d66c1&scoped=true"
import script from "./TmpPatientCard.vue?vue&type=script&lang=js"
export * from "./TmpPatientCard.vue?vue&type=script&lang=js"

import "./TmpPatientCard.vue?vue&type=style&index=0&id=6f4d66c1&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4d66c1"]])

export default __exports__